
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Edit } from "lucide-react";
import { useState } from "react";
import { EditStaffForm } from "./EditStaffForm";
import { Staff } from "@/types/staff";
import { supabase } from "@/integrations/supabase/client";

interface EditStaffDialogProps {
  staffId: string;
  initialValues: Staff;
  onStaffUpdated: () => void;
}

export const EditStaffDialog = ({ staffId, initialValues, onStaffUpdated }: EditStaffDialogProps) => {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="icon">
          <Edit className="h-4 w-4" />
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Edit Staff</DialogTitle>
        </DialogHeader>
        <EditStaffForm
          staff={initialValues}
          isOpen={open}
          onClose={() => setOpen(false)}
          onSubmit={async (values) => {
            try {
              const { error } = await supabase
                .from('staff')
                .update(values)
                .eq('id', staffId);

              if (error) throw error;

              onStaffUpdated();
              setOpen(false);
            } catch (error) {
              console.error('Error updating staff:', error);
            }
          }}
        />
      </DialogContent>
    </Dialog>
  );
};
